"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceService = void 0;
const tslib_1 = require("tslib");
const inversify_1 = require("inversify");
require("reflect-metadata");
let WorkspaceService = class WorkspaceService {
    constructor(assetsService) {
        this.assetsService = assetsService;
    }
    fetchAssets(filter, workSpaceAssetsType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const assetTypes = {
                text: 'texts',
                image: 'images',
                video: 'videos',
                logo: 'logos',
                icon: 'icons',
            };
            const type = assetTypes[workSpaceAssetsType];
            if (!filter ||
                (filter.folders && filter.folders.find((id) => id.resourceId === 'all'))) {
                return yield this.assetsService.fetchAssets(type);
            }
            else {
                if (filter.assets) {
                    return filter.assets.map((asset) => ({
                        is_deleted: false,
                        data: {
                            name: '',
                            source: asset.source,
                            selected_thumbnail: asset.thumbnail,
                        },
                    }));
                }
                return [];
            }
        });
    }
    fetchFolders(filter, type, unknownFolderName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!filter ||
                (filter.folders && filter.folders.find((id) => id.resourceId === 'all'))) {
                return yield this.assetsService.fetchFolders();
            }
            else {
                if (filter.folders) {
                    const filteredFolderIds = filter.folders.filter((id) => (id.folderId || id.resourceId) && id.resourceId !== 'all');
                    const fetchFoldersByFolderId = filteredFolderIds.filter((folder) => folder.folderId).map(folder => this.assetsService.fetchFolderById(Number(folder.folderId)).catch(() => null));
                    const fetchFoldersByResourceId = filteredFolderIds.filter((folder) => !folder.folderId).map(folder => this.assetsService.fetchResourceFromFolder(String(folder.resourceId)).catch(() => null));
                    return Promise.all([
                        Promise.all(fetchFoldersByFolderId),
                        Promise.all(fetchFoldersByResourceId)
                    ]).then(([foldersByFolderId, foldersByResourceId]) => {
                        const filteredResourceFolders = filteredFolderIds.filter((folder) => !folder.folderId).map((folder, index) => {
                            if (foldersByResourceId[index]) {
                                return {
                                    data: {
                                        id: folder.resourceId,
                                        name: unknownFolderName,
                                        types: [type]
                                    }
                                };
                            }
                            return null;
                        }).filter(Boolean);
                        return [...foldersByFolderId.filter(Boolean).flat(), ...filteredResourceFolders.flat()];
                    });
                }
                return [];
            }
        });
    }
};
exports.WorkspaceService = WorkspaceService;
exports.WorkspaceService = WorkspaceService = tslib_1.__decorate([
    (0, inversify_1.injectable)(),
    tslib_1.__metadata("design:paramtypes", [Object])
], WorkspaceService);
//# sourceMappingURL=workspace.service.js.map